<script lang="ts">
  import { getNow, getTimeZone } from "../data/clock";
  import { ensureDate, timeDistance } from "../support/dates";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let deadline = $time;

  function localTime(date: Date) {
    return date
      .toLocaleTimeString(["en-US"], {
        hour: "numeric",
        minute: "2-digit",
        timeZone: $timeZone
      })
      .toLowerCase()
      .replace(/\s(am|pm)/, "$1");
  }

  $: goal = ensureDate(deadline);
  $: distance = timeDistance($time, goal);
  $: hours = distance[0];
  $: minutes = distance[1];
</script>

{#if $time >= goal}
  Happening now
{:else if hours >= 1}
  Starting at
  {localTime(goal)}
{:else if minutes >= 1}
  Starting in
  {minutes}m
{:else}About to start{/if}
